import { ImoovaImage } from "@/app/Media/Components/Image";
import { IncidentPhoto } from "@/app/Incidents/GraphQL/incidentRecordQuery";
import { formatDateTimeLocal } from "@/lib/Formatters/formatDateTime";
import { useTranslations } from "use-intl";
import { cn } from "@/lib/utils";

export function IncidentPhotoGrid({
  photos,
  className,
}: {
  photos: IncidentPhoto[];
  className?: string;
}) {
  const t = useTranslations("incident.photos");

  if (photos.length === 0) {
    return (
      <p className="rounded-lg border border-dashed border-gray-200 px-4 py-8 text-center text-sm text-gray-400">
        {t("none")}
      </p>
    );
  }

  return (
    <ul className={cn("grid grid-cols-2 gap-3", className)}>
      {photos.map((photo) => (
        <li key={photo.id} className="space-y-1">
          <a
            href={photo.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block overflow-hidden rounded-lg border border-gray-200 bg-gray-50"
          >
            <ImoovaImage
              alt={photo.name ?? photo.file_name}
              media={photo}
              className="aspect-square w-full object-cover transition-opacity hover:opacity-80"
            />
          </a>
          <p className="truncate text-xs text-gray-500">
            {t("uploaded", {
              date: formatDateTimeLocal(photo.created_at) ?? "",
            })}
          </p>
        </li>
      ))}
    </ul>
  );
}
